/* eslint-disable */
import { CountryStore } from '../stores/country';
import { apiMessagesSaveMessages, apiMessagesSaveMessagesV2, cleanApiMessages } from './apiMessages';
import { UnitTypeValues } from './catalogs';
import { cleanDashboardStore } from './dashboard';
import { getStoreFeatureFlags } from './profile';
import { cleanZonesStore, getZonesSelect } from './zones';
import { IRequestAPIBody, apiManager } from '../REST';
import {
    ICountryAPI,
    ICountryActiveCardItem,
    ICountryIncludeOperatorItemAPI,
    ICountryInfo,
    ICountryNewAPI,
    ICountryOperatorItem,
    ICountryPATHInfoNewAPI,
    IParamsList,
    IRequestRelationshipMainItem,
    IUsageData,
} from '../interfaces';
import { IMapField, getApiTypeWithUnitType, mapApi2UiField, mapUi2ApiField } from '../instruments';

function setCountryInfoStore(info: ICountryInfo): void {
    const CountryInterface = CountryStore.getInstance();
    CountryInterface.setCountryInfo(info);
}
function setCountryOperatorsList(list: ICountryOperatorItem[]): void {
    const CountryInterface = CountryStore.getInstance();
    CountryInterface.setOperatorsList(list);
}

function setCountryActiveCardsList(list: ICountryActiveCardItem[]): void {
    const CountryInterface = CountryStore.getInstance();
    CountryInterface.setActiveCardsList(list);
}

export async function getCountryById(id: string): Promise<boolean> {
    const { resp, isError } = await apiManager.getApi('GET_COUNTRY', { id: id });
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    if (!isError) {
        if (newResponseFormatCountries) {
            const response = resp as ICountryNewAPI;
            if (response?.country?.id) {
                const countryInfo: ICountryInfo = {
                    ...mapApi2UiField({ ...response?.country }),
                    id: response.country.id.toString(),
                    zoneId: response.country.zone?.id.toString(),
                    zone: response?.country?.zone?.name,
                };
                setCountryInfoStore(countryInfo);
                const operatorsList: ICountryOperatorItem[] =
                    response?.country?.operators?.map((o) => {
                        return {
                            id: o.id.toString(),
                            ...mapApi2UiField({ ...o }),
                        };
                    }) || [];
                setCountryOperatorsList(operatorsList);
            }
        } else {
            const response = resp as ICountryAPI;
            if (response?.data?.id) {
                const zoneId = response?.data?.relationships?.zone?.data?.id;
                const zone = response?.included?.filter((i) => i.type === 'zone').find((i) => i.id === zoneId)
                    ?.attributes?.name;
                const countryInfo: ICountryInfo = {
                    id: response.data.id,
                    zoneId,
                    zone,
                    ...mapApi2UiField({ ...response?.data?.attributes }),
                };
                setCountryInfoStore(countryInfo);
                const operatorsIncluded = response.included?.filter(
                    (i) => i.type === 'operator',
                ) as ICountryIncludeOperatorItemAPI[];
                const operatorsList: ICountryOperatorItem[] =
                    response.data.relationships?.operators?.data?.map((r: IRequestRelationshipMainItem) => {
                        const operatorAttribute = operatorsIncluded.find(
                            (i: ICountryIncludeOperatorItemAPI) => i.id === r.id,
                        )?.attributes;
                        const operator: ICountryOperatorItem = {
                            id: r.id,
                            ...(operatorAttribute ? mapApi2UiField(operatorAttribute) : {}),
                        };
                        return operator;
                    }) || [];
                setCountryOperatorsList(operatorsList);
            }
        }
    }

    return !isError;
}

export async function getCountryEditRelationSelect(): Promise<void> {
    getZonesSelect();
}

export async function getCountryShowActiveCards(id: string, params: IParamsList): Promise<void> {
    const unitType = UnitTypeValues.DATA;
    const usageDataName = getApiTypeWithUnitType(`GET_USAGE_CARDS_LIST`, unitType);
    const { resp } = await apiManager.getApi(
        'GET_USAGE_CARDS_LIST',
        { searchParamsList: params },
        undefined,
        undefined,
        usageDataName,
    );

    const data = resp as Array<IUsageData>;

    const activeCardList: ICountryActiveCardItem[] = data.map((value) => {
        const mappedFields = mapApi2UiField({ ...value });

        return {
            ...mappedFields,
            id: mappedFields.cardId,
        };
    });

    setCountryActiveCardsList(activeCardList);
}

export async function patchCountry(id: string, fields: IMapField): Promise<boolean> {
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    if (newResponseFormatCountries) {
        const apiBody: ICountryPATHInfoNewAPI = {
            ...mapUi2ApiField(fields),
            id: +id,
        };
        if (fields.zoneId) {
            apiBody.zone_id = +fields.zoneId;
        }
        const { resp, isError } = await apiManager.getApi(
            id ? 'PATCH_COUNTRY' : 'POST_COUNTRY',
            { id: id },
            apiBody as IRequestAPIBody,
        );
        if (isError) {
            cleanApiMessages();
            apiMessagesSaveMessagesV2(resp.errors);
        }
        return isError;
    } else {
        const apiBody: IRequestAPIBody = {
            data: {
                type: 'country',
                attributes: mapUi2ApiField(fields),
            },
        };
        const { resp, isError } = await apiManager.getApi(id ? 'PATCH_COUNTRY' : 'POST_COUNTRY', { id: id }, apiBody);
        if (isError) {
            apiMessagesSaveMessages(resp.errors);
        }
        return isError;
    }
}

export function cleanCountryStore(): void {
    const CountryInterface = CountryStore.getInstance();
    CountryInterface.cleanStore();
    cleanZonesStore();
    cleanDashboardStore();
}
